
<template>
	<div class="menus-wrap">
		<head-info></head-info>
		<div class="relative-wrap">
			<div class="photo"><img v-if="info.photo" :src="info.photo" alt="" /></div>
			<el-descriptions :column="2" title="退费申请" border>
				<el-descriptions-item label="姓名">{{ info.name }}</el-descriptions-item>
				<el-descriptions-item
					:labelStyle="{ width: '0', backgroundColor: '#fff', border: '1px solid transparent' }"
					:contentStyle="{ width: '150px', border: '1px solid transparent', borderRightColor: '#EBEEF5' }"
				></el-descriptions-item>
				<el-descriptions-item label="身份证号">{{ info.card_id || '-' }}</el-descriptions-item>
				<el-descriptions-item
					:labelStyle="{ width: '0', backgroundColor: '#fff', border: '1px solid transparent' }"
					:contentStyle="{ width: '150px', border: '1px solid transparent', borderRightColor: '#EBEEF5' }"
				></el-descriptions-item>
				<el-descriptions-item label="性别">{{ info.gender && info.gender === 1 ? '男' : info.gender && info.gender === 2 ? '女' : '-' }}</el-descriptions-item>
				<el-descriptions-item
					:labelStyle="{ width: '0', backgroundColor: '#fff', border: '1px solid transparent' }"
					:contentStyle="{ width: '150px', border: '1px solid transparent', borderRightColor: '#EBEEF5' }"
				></el-descriptions-item>
				<el-descriptions-item label="报名序号">{{ info.serial_id || '-' }}</el-descriptions-item>
				<el-descriptions-item
					:labelStyle="{ width: '0', backgroundColor: '#fff', border: '1px solid transparent', borderBottomColor: '#EBEEF5' }"
					:contentStyle="{ width: '150px', border: '1px solid transparent', borderRightColor: '#EBEEF5', borderBottomColor: '#EBEEF5' }"
				></el-descriptions-item>
				<el-descriptions-item v-if="info.category_name" label="岗位类别" :span="2">{{ info.category_name || '-' }}</el-descriptions-item>
				<el-descriptions-item label="报考单位" :span="2">{{ info.department || '-' }}</el-descriptions-item>
				<el-descriptions-item label="报考岗位" :span="2">{{ info.position || '-' }}</el-descriptions-item>
				<el-descriptions-item v-if="info.classify" label="考试类别" :span="2">{{ info.classify }}</el-descriptions-item>
				<el-descriptions-item label="报考科目" :span="2">
					<template v-if="info.subject && info.subject.length">
						<p v-for="item in info.subject">{{ item.subject_name }}：{{ item.amount }}元</p>
					</template>
					<template v-else>
						-
					</template>
				</el-descriptions-item>
			</el-descriptions>
			<div class="main" v-html="info.refunds"></div>
			<template>
				<div class="input" v-if="info.is_pay !== 5">
					<div class="username">
						<span>接受上述内容签名</span>
						<el-form :inline="true" :model="form" ref="formRef">
							<el-form-item
								style="margin-bottom: 0px;"
								prop="username"
								:rules="[{ validator: validateName, trigger: 'blur' }, { required: true, message: '真实姓名不能为空', trigger: 'blur' }]"
							>
								<el-input size="small" maxlength="10" v-model="form.username" placeholder="请填写真实姓名"></el-input>
							</el-form-item>
						</el-form>
						<span class="tip">(注意:签名所填姓名须与真实姓名一致。)</span>
					</div>
				</div>
				<div class="checkbox" v-if="info.is_pay !== 5">
					<el-checkbox v-model="checked">我已阅读并同意遵守</el-checkbox>
					<span @click="handleTreaty()" class="href" title="点击查看">《报名系统用户协议》</span>
				</div>
				<div class="footer-btns" v-if="info.is_pay !== 5"><el-button type="primary" :disabled="!checked" @click="onSubmit()">我已阅读并确认退费</el-button></div>
				<div class="footer-btns" v-if="info.is_pay === 5"><el-button type="success">退费已申请</el-button></div>
			</template>
			<p class="date">{{ nowDate }}</p>
			<!-- 报名系统用户协议 -->
			<treaty ref="treaty"></treaty>
		</div>
	</div>
</template>

<script>
import HeadInfo from '@/components/HeadInfo';
import { reqGetRefundCandidateInfo, reqUploadFile, reqAddRefund } from '@/api';
import { validateName } from '@/tools/validate';
import {mapGetters,mapState} from "vuex";
import { Message } from 'element-ui';
import Treaty from './form/components/Treaty';
import html2canvas from 'html2canvas';
export default {
	components: {
		HeadInfo,
		Treaty
	},
	data() {
		return {
			validateName,
			form: {
				username: ''
			},
			info: '',
			subject: '',
			checked: false,
			time: 0,
			refund: '',
			nowDate: ''
		};
	},
	computed: {
		subject() {
			return this.info.subject || [];
		},
		...mapState({
			examination_id: state => state.system.examInfo.examination_id
		}),
		...mapGetters('user',['GET_USER_INFO']),
	},
	beforeRouteEnter(to, form, next) {
		reqGetRefundCandidateInfo().then(res => {
			if (res.data.rc_before) {
				Message.info('申请退费时间未到');
				next(false);
			} else if (res.data.rc_open) {
				if (res.data.is_pay === 2 || res.data.is_pay === 5) {
					next(vm => {
						vm.info = vm.GET_USER_INFO;
						Object.assign(vm.info, res.data);
					});
				} else if (res.data.is_pay === 1) {
					Message.info('未缴费，不能进行申请退费');
					next(false);
				} else if (res.data.is_pay === 5) {
					Message.info('已确认参考，不能进行申请退费');
					next(false);
				}
			} else if (res.data.rc_end) {
				Message.info('申请退费时间已过');
				next(false);
			}
		});
	},
	activated() {
		//this.getInfo();
	},
	mounted() {
		this.currentTime();
		let timer = setInterval(() => {
			this.time--;
			if (this.time <= 0) {
				this.time = 0;
				clearInterval(timer);
			}
		}, 1000);
	},
	methods: {
		getInfo() {
			reqGetUserInfo().then(res => {
				this.info = res.data;
				this.confirm = res.data.confirms;
			});
		},
		currentTime() {
			setInterval(this.formatDate, 500);
		},
		formatDate() {
			let date = new Date();
			let year = date.getFullYear(); // 年
			let month = date.getMonth() + 1; // 月
			month = month < 10 ? '0' + month : month;
			let day = date.getDate(); // 日
			day = day < 10 ? '0' + day : day;
			let week = date.getDay(); // 星期
			let weekArr = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
			let hour = date.getHours(); // 时
			hour = hour < 10 ? '0' + hour : hour; // 如果只有一位，则前面补零
			let minute = date.getMinutes(); // 分
			minute = minute < 10 ? '0' + minute : minute; // 如果只有一位，则前面补零
			let second = date.getSeconds(); // 秒
			second = second < 10 ? '0' + second : second; // 如果只有一位，则前面补零
			this.nowDate = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
		},
		// 提交
		onSubmit() {
			this.$refs['formRef'].validate(valid => {
				if (this.form.username !== this.info.name){
					return false;
				}
				if (valid) {
					this.$loading();
					let oScrollHeight = document.querySelector('.menus-wrap').scrollHeight;
					html2canvas(document.querySelector('.relative-wrap'), {
						scale: 2,
						height: oScrollHeight
					}).then(canvas => {
						let query = {};
						try {
							query = {
								file: this.dataURLtoFile(canvas.toDataURL('image/jpeg', 0.5), 'pic.jpeg')
							};
						} catch (e) {
							//TODO handle the exception
							query = {
								base64: canvas.toDataURL('image/jpeg', 0.5)
							};
						}
						reqUploadFile(query).then(res => {
							this.refund = res.data;
							this.$nextTick(() => {
								reqAddRefund({
									refund: this.refund,
									serial_id: this.info.serial_id,
									name: this.info.name,
									gender: this.info.gender,
									card_id: this.info.card_id,
									company_id: this.info.company_id,
									out_trade_no: this.info.out_trade_no,
									payment_time: this.info.payment_time,
									examination_id: this.examination_id
								}).then(res => {
									this.$message.success('退费申请成功');
									this.$store.commit('user/SET_REFRESH_NUM', 1);
									this.$store.dispatch('user/resetUserInfo');
									setTimeout(() => {
									   this.$router.push({path: '/info'})
									},1000)
								});
							});
						});
					});
				} else {
					return false;
				}
			});
		},
		// base64图片转file文件
		dataURLtoFile(dataurl, filename) {
			//将base64转换为文件，dataurl为base64字符串，filename为文件名（必须带后缀名，如.jpg,.png）
			var arr = dataurl.split(','),
				mime = arr[0].match(/:(.*?);/)[1],
				bstr = atob(arr[1]),
				n = bstr.length,
				u8arr = new Uint8Array(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new File([u8arr], filename, {
				type: mime
			});
		},
		// 查看协议
		handleTreaty() {
			this.$refs.treaty.dialogVisible = true;
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/color.scss';

.menus-wrap {
	display: flex;
	flex-direction: column;
	align-items: center;
	.el-table {
		margin-top: 50px;
	}
	.el-button {
		margin: 30px auto;
	}
	.tip {
		font-size: 24px;
		font-weight: bold;
		color: #ff6f72;
		text-align: left;
	}
}

	#rcorners1 {
	  border-radius: 25px;
	  border: 2px solid #2461ed;
	  background: #e3ebfd;
	  padding: 20px;  
	}
.relative-wrap {
	position: relative;
	margin: 15px auto 0;
	width: 800px;
	.photo {
		width: 150px;
		height: 150px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		top: 135px;
		right: 116px;
		transform: translate(50%, -50%);

		img {
			max-width: 150px;
			max-height: 150px;
			object-fit: cover;
		}
	}

	.input {
		margin: 50px 50px 0;
		background: #f9f9f9;
		padding: 10px 20px;

		.username {
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 12px;
			font-weight: 500;
			color: #0a0a0a;
			margin-top: 15px;

			.el-input {
				width: 200px;
				margin: 0 10px;
			}
		}

		.tip {
			font-size: 12px;
			font-weight: 500;
			color: #ff0707;
			text-align: center;
		}
	}

	.checkbox {
		margin: 20px 50px;
		text-align: center;
	}
	::v-deep.el-descriptions {
		padding: 0 20px;
		.el-descriptions__header {
			margin: 0;
			padding: 10px 0;
			justify-content: center;
			background-color: $--color-primary;
			color: #ffffff;
			.el-descriptions__title {
				font-weight: 500;
			}
		}
		.el-descriptions__body {
			.el-descriptions__table .el-descriptions-item__cell {
				line-height: 32px;
			}
			th,
			td {
				padding-left: 30px;
			}
		}
	}
}
</style>
